import { useEffect } from 'react';

import { EnergyBasketFragment } from '@generated/gql/graphql';
import { useUpdatedTariffModalContext } from '@providers/basket/UpdatedTariffModalProvider/Context';

import { useHandleTariffUpdate } from './useHandleTariffUpdate';

const useUpdatedEnergyModal = (
  energy: Nullable<EnergyBasketFragment>,
  hasExpiredBundle: boolean
) => {
  const { resetModalState } = useUpdatedTariffModalContext();
  const selectedQuote = energy?.selectedQuote;

  const { isLoading, handleUpdateQuotes } = useHandleTariffUpdate();
  const shouldUpdate = !!selectedQuote && !selectedQuote.isEligible;

  useEffect(() => {
    if (!shouldUpdate) {
      // Ensures that the modalState is reset when modal stays closed
      return resetModalState();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldUpdate]);

  const closeModal = () => resetModalState();

  return {
    isOpen: shouldUpdate && !hasExpiredBundle,
    isLoading,
    closeModal,
    handleUpdateQuotes,
  };
};

export { useUpdatedEnergyModal };
